// names goes to the mapping are transformed:
// 1. to lowercase
// 2. _ are replaced with space
// 3. trimmed
// 4. VOY_ and LD_ prefixes are removed
// 5. (LD) suffix is removed
const NAMES_MAPPING = {
  created: 'created at',
  'recipient id': 'user id',
  'email open': 'email opened',
  'email introduce to sale': 'hot lead trigger',
  'email click': 'email clicked',
  'source (old)': 'source',
  'email send': 'email sent',
  'suppression list include': 'suppression list',
  'sms send': 'sms sent',
  'estimated household income': 'est. household income',
  'auto body type': 'auto type',
  'lgbt supporters/donors': 'LGBTQ+ Donor/Supporter',
  credrate: 'credit rating',
  singparent: 'single parent',
  nascar: 'NASCAR',
  zip: 'ZIP',
  'childrens products': 'children products',
  'eu limits detected at': 'EU limits detected at',
  'ctm ad id': 'CTM ad id',
  'ctm ad name': 'CTM ad name',
  'ctm ad set name': 'CTM ad set name',
  'ctm campaign name': 'CTM campaign name',
  'personal emails validation status': 'Personal Email Validation Status',
  'cart abandonment': 'cart abandoned',
  'collection view': 'viewed collection',
  'website visit': 'visited website',
  'return visit': 'return visitor',
  'checkout abandonment': 'checkout abandoned',
  'product view': 'viewed product',
  type: 'contact type',
};

const systemVariables = ['gender'];

export const formatVariableNames = (name: string) => {
  const friendlyName = `${NAMES_MAPPING[name.toLowerCase()] || name}${
    systemVariables[name.toLocaleLowerCase()] ? ' (system)' : ''
  }`;
  return friendlyName;
};

export const normalizeVariableName = (variableName: string) => {
  const prefixes = ['VOY_', 'LD_'];
  const suffix = '(LD)';
  let value = variableName;
  value = prefixes.reduce(
    (acc, prefix) => (acc.startsWith(prefix) ? acc.slice(prefix.length) : acc),
    variableName,
  );

  if (value.endsWith(suffix)) {
    value = value.slice(0, -suffix.length);
  }
  const normalizedName = value.replace(/_/g, ' ')?.toLowerCase()?.trim();

  return formatVariableNames(normalizedName);
};

export const hiddenVariables = [
  'sessions count',
  'last active',
  'email reply',
  'wday',
  'suppressed',
  'email reply',
  'ld perm individual id',
  'fb messenger user id',
  'integration syncs',
  'sms send',
  'source',
  'suppressed_email',
  'suppressed_phone',
  'type',
];

type VariablesCategoriesType = 'consumer' | 'engagement' | 'conversions';

// contacts.selectedContact.variables.variable.friendlyName is used for this list
export const variablesByCategory: Record<VariablesCategoriesType, string[]> = {
  consumer: [
    'created at',
    'first name',
    'last name',
    'full name',
    'gender',
    'age',
    'age range',
    'phone',
    'direct number',
    'mobile phone',
    'personal phone',
    'email',
    'email domain',
    'handle',
    'location',
    'user id',
    'income range',
    'married',
    'net worth',
    'homeowner',
    'children',
    'personal address',
    'personal address 2',
    'personal city',
    'Personal Email Validation Status',
    'personal state',
    'personal zip',
    'personal zip4',
    'IP address',
  ],
  conversions: [
    'cart abandoned',
    'viewed collection',
    'visited website',
    'return visitor',
    'checkout abandoned',
    'viewed product',
    'synced to CRM',
    'synced to ad network',
  ],
  engagement: [
    'last active',
    'clicks',
    'time on site',
    'page views',
    'profile synced at',
    'scroll depth',
    'verified user',
    'link to conversation',
    'sessions count',
    'web sessions count',
    'email clicked',
    'hot lead trigger',
    'email opened',
    'email reply',
    'email sent',
    'form filled',
    'integration syncs',
    'landing page domain',
    'landing page full url',
    'landing page url',
    'last session',
    'no interaction',
    'suppressed',
    'suppressed email',
    'suppressed phone',
    'suppression list',
    'sms sent',
    'unsubscribed',
  ],
};
